// src/hooks/use-i18n-feature.ts
import * as React from "react";
import "@refinedev/core";
var I18nFeatureContext = React.createContext(void 0);
var useI18nFeature = () => React.useContext(I18nFeatureContext);

export {
  I18nFeatureContext,
  useI18nFeature
};
//# sourceMappingURL=chunk-3NNKVCYB.mjs.map